module.exports = __webpack_public_path__ + "img/8.ee6df254.png";